const getFirstValidNumber = (...values) => {
  for (const value of values) {
    const parsedValue = parseFloat(value)
    if (Number.isFinite(parsedValue)) {
      return parsedValue
    }
  }
  return null
}

const getSceneDescription = scene =>
  scene?.description ||
  scene?.scene_description ||
  scene?.scene_location ||
  scene?.location ||
  scene?.title ||
  ''

const getShotDescription = (shot, shotIndex) =>
  shot?.title ||
  shot?.shot_description ||
  shot?.video_prompt ||
  shot?.shot_direction ||
  shot?.initial_image_prompt ||
  shot?.scenery ||
  `Shot ${shotIndex + 1}`

export const buildVideoSuggestionsPayload = (
  videoUrl,
  shotList = [],
  sourceGenerationVideoId = ''
) => {
  if (!videoUrl || !sourceGenerationVideoId) {
    return {
      payload: null,
      sceneCount: 0,
      shotCount: 0
    }
  }

  let shotCount = 0
  let includedSceneCount = 0

  const shooting_list_with_durations = (shotList || []).reduce(
    (accumulator, scene) => {
      const shots = Array.isArray(scene?.shots) ? scene.shots : []

      if (!shots.length) {
        return accumulator
      }

      includedSceneCount += 1

      const mappedShots = shots.map((shot, shotIndex) => {
        shotCount += 1

        const shotDuration = getFirstValidNumber(
          shot?.generated_video_duration,
          shot?.video_duration,
          shot?.calculated_duration,
          shot?.videoDuration
        )

        return {
          [`shot ${shotIndex + 1}`]: {
            shot_description: getShotDescription(shot, shotIndex),
            video_duration: shotDuration !== null ? shotDuration : 0
          }
        }
      })

      accumulator[`scene ${includedSceneCount}`] = {
        scene_description: getSceneDescription(scene),
        shots: mappedShots
      }

      return accumulator
    },
    {}
  )

  const sceneCount = Object.keys(shooting_list_with_durations).length

  if (!sceneCount || !shotCount) {
    return {
      payload: null,
      sceneCount,
      shotCount
    }
  }

  return {
    payload: {
      s3_url: videoUrl,
      video_id: sourceGenerationVideoId,
      shooting_list_with_durations
    },
    sceneCount,
    shotCount
  }
}
